import { Box, CircularProgress, Fade, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

interface IProps {
	message: string;
	loading: boolean;
}

const FullPageLoadingSplash = ({ message, loading, children }: PropsWithChildren<IProps>) => {
	if (!loading) return <Box>{children}</Box>;
	return (
		<Box sx={{ textAlign: 'center', mt: 8 }}>
			<Fade in timeout={400}>
				<Box sx={{ mt: 2 }}>
					<Typography variant='h4' color='secondary'>
						{message}
					</Typography>
					<Box sx={{ marginTop: '40px' }}>
						<CircularProgress color='secondary' size={100} />
					</Box>
				</Box>
			</Fade>
		</Box>
	);
};

export default FullPageLoadingSplash;
